import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

let analytics: any = null;

isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});

export { app, auth, analytics };


export const trackEvent = (
  eventName: string,
  params: Record<string, any> = {}
) => {
  if (!window.gtag) {
    console.warn("gtag is not available");
    return;
  }

  const isLocalhost = window.location.hostname === "localhost";

  window.gtag("event", eventName, {
    ...params,
    debug_mode: isLocalhost,
  });

  if (isLocalhost) {
    console.log(`[GA4 Debug]: Sent ${eventName}`, params);
  }
};